import { ScrollTrigger, createScrollTrigger } from 'scripts/lib/gsap/scrollTrigger';

const header = document.querySelector('.header');
const menu = document.querySelector('.mobile-menu');


export enum HeaderColorClass {
    Blue = 'color-blue',
    Violet = 'color-violet',
    Green = 'color-green',
    White = 'color-white',
    Red = 'color-red',
    Black = 'color-black',
    HeroBlack = 'color-hero-black',
}

export function clearHeaderMenuColor() {
    const headerClassList = header.classList;
    headerClassList.forEach((className) => {
        const splittedClassName = className.split('-');
        if (splittedClassName[0] === 'color') {
            headerClassList.remove(className);
        }
    });

    const menuClassList = menu.classList;
    menuClassList.forEach((className) => {
        const splittedClassName = className.split('-');
        if (splittedClassName[0] === 'color') {
            menuClassList.remove(className);
        }
    });
}

export function checkHeaderMenuColor(color: HeaderColorClass) {
    const headerClassList = header.classList;
    const menuClassList = menu.classList;

    return headerClassList.contains(color) && menuClassList.contains(color);
}

export function addHeaderMenuColor(className: HeaderColorClass) {
    header.classList.add(className);
    menu.classList.add(className);
}

export type ChangeColorHeaderConfig = {
    element: HTMLElement;
    color?: HeaderColorClass;
    triggerVars?: ScrollTrigger.Vars;
};


export function setupTriggerChangeColorHeader(config: ChangeColorHeaderConfig) {

    const { element, color, triggerVars } = config;
    return createScrollTrigger({
        trigger: element,
        onEnter: () => {
            clearHeaderMenuColor();
            if (color) {
                addHeaderMenuColor(color);
            }
        },
        onEnterBack: () => {
            clearHeaderMenuColor();
            if (color) {
                addHeaderMenuColor(color);
            }
        },
        // onLeaveBack: () => {
        //     clearHeaderMenuColor();
        // },
        ...triggerVars,
    });
}
